import { ReactElement } from 'react';
// eslint-disable-next-line import/no-unresolved
import { PlanEditor } from '@mapado/seating/demo-specific';
import SeatConfigSelectorContainer from '../SeatConfigSelector';
import useQueryNumberParam from '../useQueryNumberParam';

export default function DemoEditor(): ReactElement {
  const seatConfigId = useQueryNumberParam('seatConfigId', 103);

  return (
    <>
      <h3>Editor</h3>
      <SeatConfigSelectorContainer />
      <PlanEditor key={`${seatConfigId}`} seatConfigId={seatConfigId} />
    </>
  );
}
